import { Component } from '@angular/core';



@Component({
    selector: 'modal-toolbar',
    styles: [
        `
        :host {
            flex: 1 0 auto;
            padding: 0.5rem 1.5rem;
            color: #C2CAD4;
        }
        `
    ],
    host: {
        class: 'd-flex bg-icon text-white'
    },
    template: `
        <ng-content></ng-content>
    `,
})
export class ModalToolbarComponent {}
